import type {
  CursorPaginationOptions,
  CursorPaginationQuery,
  OffsetPaginationOptions,
  OffsetPaginationQuery,
  PaginationModeQuery,
  SortingQuery,
  SortOptions,
} from '../types'

type Extracted<T> = OffsetPaginationOptions & CursorPaginationOptions & SortOptions & {
  remaining: Omit<
    T,
    keyof PaginationModeQuery | keyof OffsetPaginationQuery | keyof CursorPaginationQuery | keyof SortingQuery | keyof PaginationModeQuery
  >
}

export function extractQuery<T extends Record<string, any>>(query: T): Extracted<T> {
  const { paginationMode, page, per, before, after, sortFields, sortDirections, ...remaining } = query

  return {
    ...((page || per) && paginationMode !== 'cursor' ? { pageInfo: { page, per } } : {}),
    ...((before || after || per) && paginationMode !== 'offset' ? { cursor: { before, after, per } } : {}),
    ...(sortFields || sortDirections ? { sorts: { fields: sortFields, directions: sortDirections } } : {}),
    remaining,
  }
}
